var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var NotNegativeIntegerValidatorDirective = /** @class */ (function () {
    function NotNegativeIntegerValidatorDirective() {
        this.validator = this.validateNotNegativeIntegerFactory();
    }
    NotNegativeIntegerValidatorDirective_1 = NotNegativeIntegerValidatorDirective;
    NotNegativeIntegerValidatorDirective.prototype.validateNotNegativeIntegerFactory = function () {
        return function (c) {
            if (c.value == null) {
                return null;
            }
            var REGEXP = /^(([1-9]\d*)|0)$/;
            return REGEXP.test(c.value) ? null :
                { 'notNegativeInteger': { value: c.value } };
        };
    };
    NotNegativeIntegerValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var NotNegativeIntegerValidatorDirective_1;
    NotNegativeIntegerValidatorDirective = NotNegativeIntegerValidatorDirective_1 = __decorate([
        Directive({
            selector: '[not-negative-integer][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return NotNegativeIntegerValidatorDirective_1; }), multi: true }
            ]
        })
    ], NotNegativeIntegerValidatorDirective);
    return NotNegativeIntegerValidatorDirective;
}());
export { NotNegativeIntegerValidatorDirective };
